import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@arcadeai/design-system/components/ui/atoms/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@arcadeai/design-system/components/ui/atoms/tooltip";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import { Info } from "lucide-react";
import { useFormContext } from "react-hook-form";
import type { AuthProvider } from "@/app/oauth/types";
import { EnforcedResponseMapInput } from "./enforced-response-map-input";
import { RequestParametersInput } from "./request-parameters-input";

const AUTH_METHOD_ITEMS = {
  none: "None",
  client_secret_basic: "Client Secret Basic",
};

export const TokenRequestFields = () => {
  const form = useFormContext<AuthProvider>();

  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="oauth2.token_request.auth_method"
        render={({ field }) => (
          <FormItem>
            <div className="flex w-full items-center justify-between gap-4">
              <FormLabel>Authentication Method</FormLabel>
              <TooltipProvider delay={200}>
                <Tooltip>
                  <TooltipTrigger
                    render={<span className="text-gray-500 text-sm" />}
                  >
                    <Info className="mr-1 size-4" />
                  </TooltipTrigger>
                  <TooltipContent>
                    Currently, client secret basic is the only supported
                    authentication method.
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
            <Select
              defaultValue={field.value}
              disabled
              items={AUTH_METHOD_ITEMS}
              onValueChange={field.onChange}
            >
              <FormControl>
                <SelectTrigger className="w-full">
                  {/* TODO: change this placeholder when we have more auth methods */}
                  <SelectValue placeholder="Client Secret Basic" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="none">None</SelectItem>
                <SelectItem value="client_secret_basic">
                  Client Secret Basic
                </SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="oauth2.token_request.response_content_type"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Response Content Type</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select content type" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="application/json">
                  application/json
                </SelectItem>
                <SelectItem value="application/x-www-form-urlencoded">
                  application/x-www-form-urlencoded
                </SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="oauth2.token_request.params"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <RequestParametersInput
                form={form}
                name={field.name}
                onChange={field.onChange}
                value={field.value || {}}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="oauth2.token_request.response_map"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <EnforcedResponseMapInput
                form={form}
                name={field.name}
                onChange={field.onChange}
                value={field.value || {}}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
